import React, { Component } from "react";
import DatePicker from "react-datepicker";
import ReactTable from "react-table";
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import request from "../../../lib/requester";
import _, { toNumber } from "lodash";
import moment from "moment";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import Autocomplete from "../../../component/autocomplete";
import axios from "axios";
import requester from "../../../lib/requester";

class ReceiptDocDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      dataDetail: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      submittedDateFrom: "",
      submittedDateTo: "",
      sAwbNo: "",
      error: [],
      success: "",
      header: [],
      lovStatus: [],
      lovReason: [],
      ada_insert: false,
    };
  }

  componentDidMount = () => {
    this.handleSearch();

    let { lovStatus, lovReason } = this.state;
    lovStatus.push({ code: "REJECT", text: "Reject" });
    lovStatus.push({ code: "APPROVE", text: "Approve" });
    // lovReason.push({
    //   code: "COMPLETE_AND_MATCH",
    //   text: "Doc Complete and Match",
    // });
    // lovReason.push({ code: "OUT_OF_AWB", text: "Doc Not Exist in AWB" });
    // lovReason.push({ code: "INCOMPLETE", text: "Doc Incomplete" });
    // lovReason.push({ code: "NOT_RECEIVED", text: "Doc Not Received" });
  };

  handleSearch = () => {
    let url = "/api/collect/v1/monitoring/get-detail-doc-cab-receipt";
    let { id } = this.props.match.params;
    let param = {
      doc_id: id,
    };
    this.setState({ loading: true });
    request.postCollect(url, param, {
      success: function (response) {
        let { header, detail } = response.data.data;
        let { dataDetail, lovReason } = this.state;
        console.log(header);
        detail.map((item, index) => {
          // lovReason.push({
          //   dataindex: index,
          //   code: "COMPLETE_AND_MATCH",
          //   text: "Doc Complete and Match",
          // });
          lovReason.push({
            dataindex: index,
            code: "OUT_OF_AWB",
            text: "Doc Not Exist in AWB",
          });
          lovReason.push({
            dataindex: index,
            code: "INCOMPLETE",
            text: "Doc Incomplete",
          });
          lovReason.push({
            dataindex: index,
            code: "NOT_RECEIVED",
            text: "Doc Not Received",
          });

          dataDetail.push({
            verified: "N",
            trx_id: item.trx_id,
            trx_number: item.trx_number,
            ttf_no: item.ttf_no,
            customer_id: item.cust_des_id,
            customer_name: item.cust_des_name,
            status: "REJECT",
            reason: "NOT_RECEIVED",
            notes: item.notes,
            popular_name: item.popular_name,
            new_insert: "N"
          });
        });

        console.log(this.state.lovReason);
        this.setState({
          header: header,
          loading: false,
          dataTable: dataDetail,
        });
        this.getProgramType();
        this.getDocumentList();
      }.bind(this),
      error: function (e) {
        console.log(e);
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  handleSubmit = (e) => {
    // if (this.validateSubmit()) {
    let { id } = this.props.match.params;
    let { dataTable, header, user } = this.state;

    let param = {
      doc_id: id,
      org_id: user.org_id,
      role_confirm: user.role_name,
      username: user.username,
      org_name: user.org_name,
      dataheader: header,
      dataline: dataTable,
      type: "cabang",
    };

    // console.log(param);

    this.setState({ loading: true });
    let url = "/api/collect/v1/monitoring/submit-receipt-cab";
    request.postCollect(url, param, {
      success: function (response) {
        let { message } = response.data;
        window.scrollTo(0, 0);
        this.setState({ loading: false, success: message, error: [] });
        window.setTimeout(() => {
          this.props.history.push("/admin/documentmonitor/receiptcab");
          // window.location.reload();
        }, 2000);
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
    // }
  };

  handleTestEmail = (e) => {
    // if (this.validateSubmit()) {
    let { id } = this.props.match.params;
    let { dataTable, header, user } = this.state;

    let param = {
      awb_id: id,
      org_id: user.org_id,
      role_confirm: user.role_name,
      username: user.username,
      org_name: user.org_name,
      dataheader: header,
      dataline: dataTable,
    };

    // console.log(param);

    this.setState({ loading: true });
    let url = "/api/collect/v1/monitoring/test-send-email";
    request.postCollect(url, param, {
      success: function (response) {
        let { message } = response.data;
        window.scrollTo(0, 0);
        this.setState({ loading: false, success: message, error: [] });
        window.setTimeout(() => {
          // this.props.history.push("/admin/documentmonitor/receiptcab");
          // window.location.reload();
        }, 2000);
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
    // }
  };

  handleKeyDown = (e) => {
    // alert("ok");

    let thisreason = [];

    if (
      e.key === "Enter" ||
      e.keyCode === 13 ||
      e.key === "Tab" ||
      e.keyCode === 9
    ) {
      e.preventDefault();
      //   if (this.validateScan()) {

      let data = this.state.dataTable;
      let newData = [];

      if (e.target.value.length > 0) {
        this.setState({ dataDetail: this.state.dataTable });

        data.forEach((item, index) => {
          newData.push({
            verified: item.trx_number == e.target.value ? "Y" : item.verified,
            trx_id: item.trx_id,
            trx_number: item.trx_number,
            ttf_no: item.ttf_no,
            customer_id: item.customer_id,
            customer_name: item.customer_name,
            status: item.trx_number == e.target.value ? "APPROVE" : item.status,
            reason:
              item.trx_number == e.target.value
                ? "COMPLETE_AND_MATCH"
                : item.reason,
            notes: item.notes,
            popular_name: item.popular_name,
            new_insert: item.new_insert,
          });
        });

        newData.forEach((item, index) => {
          if (item.status == "APPROVE") {
            thisreason.push({
              dataindex: index,
              code: "COMPLETE_AND_MATCH",
              text: "Doc Complete and Match",
            });
          } else {
            thisreason.push({
              dataindex: index,
              code: "OUT_OF_AWB",
              text: "Doc Not Exist in AWB",
            });
            thisreason.push({
              dataindex: index,
              code: "INCOMPLETE",
              text: "Doc Incomplete",
            });
            thisreason.push({
              dataindex: index,
              code: "NOT_RECEIVED",
              text: "Doc Not Received",
            });
          }

        });

        if (this.cekinvoiceNoExist(e.target.value)) {
          let url = "/api/orafin/v1/collection/get-invoice-and-ttf";
          let param = {
            datascan: "'" + e.target.value + "'",
            branchid: this.state.user.org_id,
            doctype: "INV",
          };
          this.setState({ loading: true });
          request.postOracle(url, param, {
            success: function (response) {
              // this.handleApprove();
              let { data } = response.data;

              let dataline = data;
              this.setState({ ada_insert: true });

              dataline.map((item, index) => {
                newData.unshift({
                  verified: "Y",
                  trx_id: item.CUSTOMER_TRX_ID,
                  trx_number: item.TRX_NUMBER,
                  ttf_no: item.TTF_NO,
                  customer_id: item.CUSTOMER_ID,
                  customer_name: item.CUSTOMER_NAME,
                  status: "REJECT",
                  reason: "OUT_OF_AWB",
                  notes: "",
                  popular_name: item.POPULAR_NAME_CUSTOMER,
                  new_insert: "Y",
                });
              });

              this.setState({
                loading: false,
                // dataTable: data,
              });
            }.bind(this),
            error: function (e) {
              alert("Failed to checking data");
            },
          });

          thisreason.map((item, index) => {
            item.dataindex = item.dataindex + 1;
          });

          thisreason.push({
            dataindex: 0,
            code: "OUT_OF_AWB",
            text: "Doc Not Exist in AWB",
          });
          thisreason.push({
            dataindex: 0,
            code: "INCOMPLETE",
            text: "Doc Incomplete",
          });
          thisreason.push({
            dataindex: 0,
            code: "NOT_RECEIVED",
            text: "Doc Not Received",
          });
        }

        console.log(newData);

        // this.setState({ loading: true });
        this.setState({ lovReason: thisreason });
        this.setState({ dataTable: newData });
        // this.setState({ loading: false });
        console.log(thisreason);
        document.getElementById("scanfield").value = "";
        // document.getElementById("myTable").refe;
      }
      //   }
    }
  };

  cekinvoiceNoExist = (trx_number) => {
    let find = _.find(this.state.dataTable, function (o) {
      return o.trx_number === trx_number;
    });
    return find ? false : true;
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "Verified",
          accessor: "verified",
          width: 100,
          Cell: (row) => {
            if (row.value == "Y") {
              return (
                <div style={{ textAlign: "center", color: "green" }}>
                  <span>
                    <a className="fa fa-check"></a>
                  </span>
                </div>
              );
            } else {
              return (
                <div style={{ textAlign: "center", color: "red" }}>
                  <span>
                    <a className="fa fa-times"></a>
                  </span>
                </div>
              );
            }
          },
        },
        {
          Header: "Invoice No.",
          accessor: "trx_number",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          width: 120,
        },
        {
          Header: "TTF No",
          accessor: "ttf_no",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          width: 150,
        },
        {
          Header: "Customer Name",
          accessor: "customer_name",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          width: 250,
        },

        {
          Header: "Status",
          accessor: "status",
          Cell: (row) => {
            return (
              <div>
                <span>
                  <select
                    className="form-control"
                    name="lovstatus"
                    id={"lovstatus_" + row.index}
                    data-index={row.index}
                    // e.target.attributes.getNamedItem("data-index").value;
                    onChange={this.handleStatus.bind(this)}
                  >
                    {this.state.lovStatus.map((item, index) => (
                      <option
                        value={item.code}
                        key={index}
                        selected={row.value == item.code ? true : false}
                      >
                        {item.text}
                      </option>
                    ))}
                  </select>
                </span>
              </div>
            );
          },
          width: 150,
        },
        {
          Header: "Reason",
          accessor: "reason",
          Cell: (row) => {
            return (
              <div>
                <span>
                  <select
                    className="form-control"
                    id={"lovreason_" + row.index}
                    data-index={row.index}
                    onChange={this.handleReason.bind(this)}
                  >
                    {this.state.lovReason.map((item, index) =>
                      // if (item.index == row.index ) {
                      item.dataindex == row.index ? (
                        <option
                          value={item.code}
                          key={index}
                          selected={row.value == item.code ? true : false}
                        >
                          {item.text}
                        </option>
                      ) : (
                        ""
                      )
                    )}
                    )
                  </select>
                </span>
              </div>
            );
          },

          width: 250,
        },
        {
          Header: "Notes",
          accessor: "notes",
          filterable: false,
          width: 250,

          Cell: (row) => {
            return (
              <span>
                <input
                  data-index={row.index}
                  // onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={row.value}
                  onChange={this.handleNotes.bind(this)}
                  //   value="2111"
                  style={{
                    width: "100%",
                    height: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              </span>
            );
          },
        },
        {
          Header: "Delete",
          accessor: "new_insert",
          filterable: false,
          width: 80,
          Cell: (row) => {
            if (row.value == 'Y'){
              return (
                <div style={{ textAlign: "center" }}>
                  <span>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => {
                        this.goRemove(row.index);
                      }}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </span>
                </div>
              );
            }
            else
             return (
               <div style={{ textAlign: "center" }}>
                 <span>
                   {/* <button
                     type="button"
                     className="btn btn-danger btn-sm"
                     onClick={() => {
                       this.goRemove(row.index);
                     }}
                   >
                     <i className="fas fa-times" />
                   </button> */}
                 </span>
               </div>
             );
          },
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        id="myTable"
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  goRemove = (index1) => {
      let data1 = this.state.dataTable;
      data1.splice(index1, 1);
      this.setState({dataTable:data1});
      // console.log(index);
      // console.log(data1);

this.state.lovReason.map((item, index) => {
  if (item.dataindex == index1){
    this.state.lovReason.splice(index, 1);
  }
})

console.log(this.state.lovReason);
      
  };

  handleNotes = (e) => {
    // let { row } = rows;
    let thisreason = [];

    let data = this.state.dataTable;
    let newData = [];
    data.map((item, index) => {
      if (index == e.target.attributes.getNamedItem("data-index").value) {
        item.notes = e.target.value;
      }
    });

    this.setState({ dataTable: data });
    console.log(this.state.dataTable);
  };

  handleStatus = (e) => {
    // let { row } = rows;
    let thisreason = [];

    let data = this.state.dataTable;
    let newData = [];
    data.map((item, index) => {
      if (index == e.target.attributes.getNamedItem("data-index").value) {
        item.status = e.target.value;
      }
    });

    data.map((item, index) => {
      if (item.status == "APPROVE") {
        thisreason.push({
          dataindex: index,
          code: "COMPLETE_AND_MATCH",
          text: "Doc Complete and Match",
        });
      } else {
        thisreason.push({
          dataindex: index,
          code: "OUT_OF_AWB",
          text: "Doc Not Exist in AWB",
        });
        thisreason.push({
          dataindex: index,
          code: "INCOMPLETE",
          text: "Doc Incomplete",
        });
        thisreason.push({
          dataindex: index,
          code: "NOT_RECEIVED",
          text: "Doc Not Received",
        });
      }
    });

    // var x = document.getElementById(
    //   "lovreason_" + e.target.attributes.getNamedItem("data-index")
    // );

    //  var option = document.createElement("option");
    //  option.code = "COMPLETE_AND_MATCH";
    //  option.text = "Complete and Match";

    // var x = document.getElementById(
    //   "lovreason_" + e.target.attributes.getNamedItem("data-index")
    // );
    // var option = document.createElement("option");
    // option.value = "COMPLETE_AND_MATCH";
    // option.text = "Complete and Match";
    // x.add(option, null);

    // this.setState({ lovReason: [] });

    // let thisreason = [];

    // if (e.target.value == "APPROVE") {
    //   thisreason.push({
    //     index: e.target.attributes.getNamedItem("data-index").value,
    //     code: "COMPLETE_AND_MATCH",
    //     text: "Complete and Match",
    //   });
    // } else {
    //   thisreason.push({
    //     index: e.target.attributes.getNamedItem("data-index").value,
    //     code: "OUT_OF_AWB",
    //     text: "Out of AWB",
    //   });
    //   thisreason.push({
    //     index: e.target.attributes.getNamedItem("data-index").value,
    //     code: "INCOMPLETE",
    //     text: "Incomplete",
    //   });
    //   thisreason.push({
    //     index: e.target.attributes.getNamedItem("data-index").value,
    //     code: "NOT_RECEIVED",
    //     text: "Not Received",
    //   });
    // }

    // this.setState({ loading: true });
    this.setState({ lovReason: thisreason });
    this.setState({ dataTable: data });
    console.log(this.state.dataTable);
    // console.log(e.target.attributes.getNamedItem("data-index").value);
  };

  handleReason = (e) => {
    // let { row } = rows;
    let data = this.state.dataTable;
    // let newdata=[]
    let newData = [];

    // let putReason = "";

    // if (
    //   document.getElementById(
    //     "lovstatus_" + e.target.attributes.getNamedItem("data-index").value
    //   ).value == "APPROVE" &&
    //   e.target.value != "COMPLETE_AND_MATCH"
    // ) {
    //   alert("Status Approve should be COMPLETE AND MATCH");
    //   putReason = "COMPLETE_AND_MATCH";
    // }

    // if (
    //   document.getElementById(
    //     "lovstatus_" + e.target.attributes.getNamedItem("data-index").value
    //   ).value == "APPROVE" &&
    //   e.target.value != "COMPLETE_AND_MATCH"
    // ) {
    //   data.map((item, index) => {
    //     if (index == e.target.attributes.getNamedItem("data-index").value) {
    //       item.reason = "COMPLETE_AND_MATCH";
    //       document.getElementById(
    //         "lovstatus_" + e.target.attributes.getNamedItem("data-index").value
    //       ).selected = "COMPLETE_AND_MATCH";
    //     }
    //   });
    // } else {
    //   data.map((item, index) => {
    //     if (index == e.target.attributes.getNamedItem("data-index").value) {
    //       item.reason = e.target.value;
    //     }
    //   });
    // }

    // newData = data;

    data.map((item, index) => {
      if (index == e.target.attributes.getNamedItem("data-index").value) {
        item.reason = e.target.value;
      }
    });

    // this.setState({ loading: true });
    this.setState({ dataTable: data });
    console.log(this.state.dataTable);
    // console.log(e.target.attributes.getNamedItem("data-index").value);
    document.getElementById("scanfield").value = "";
  };

  handleCancel = () => {
    this.props.history.push("/admin/documentmonitor/receiptcab");
  };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fas fa-check"></i> {this.state.success}
        </div>
      );
    }
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  {/* <div className="card-header">Form</div> */}
                  <div className="card-body">
                    {this.showSuccess()}
                    {this.showError()}
                    {/* <form className="form-horizontal"> */}
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Document No.
                            </label>
                            <div className="col-sm-8">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                // placeholder="AWB Number"
                                // onChange={this.handleChangeAwb.bind(this)}
                                value={this.state.header.doc_no}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Awb No.
                            </label>
                            <div className="col-sm-8">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                // placeholder="AWB Number"
                                // onChange={this.handleChangeAwb.bind(this)}
                                value={this.state.header.awb_no}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Sender
                            </label>
                            <div className="col-sm-8">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                // placeholder="AWB Number"
                                // onChange={this.handleChangeAwb.bind(this)}
                                value={this.state.header.org_src_name}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Document Date
                            </label>
                            <div className="col-sm-8">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                // placeholder="AWB Number"
                                // onChange={this.handleChangeAwb.bind(this)}
                                value={
                                  this.state.header.doc_date !== null &&
                                  this.state.header.doc_date !== "" &&
                                  this.state.header.doc_date !== "null"
                                    ? moment(
                                        new Date(this.state.header.doc_date)
                                      ).format("DD-MMM-YYYY")
                                    : ""
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Awb Date
                            </label>
                            <div className="col-sm-8">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                // placeholder="AWB Number"
                                // onChange={this.handleChangeAwb.bind(this)}
                                value={
                                  this.state.header.awb_date !== null &&
                                  this.state.header.awb_date !== "" &&
                                  this.state.header.awb_date !== "null"
                                    ? moment(
                                        new Date(this.state.header.awb_date)
                                      ).format("DD-MMM-YYYY")
                                    : ""
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Destination
                            </label>
                            <div className="col-sm-8">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                // placeholder="AWB Number"
                                // onChange={this.handleChangeAwb.bind(this)}
                                value={this.state.header.org_des_name}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Scan Invoice
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="scanfield"
                                name="ref_number"
                                placeholder="Place your cursor here for scan"
                                // onChange={this.handleChangeInputScan.bind(this)}
                                onKeyDown={this.handleKeyDown.bind(this)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="clearfix">&nbsp;</div>
                      <div className="row">
                        <div className="col-lg-12">{this.renderTable()}</div>
                      </div>
                      &nbsp;
                      <div className="row">
                        <div className="col-md-9">
                          <div className="col-sm-8">
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={this.handleSubmit.bind(this)}
                            >
                              Confirmed
                            </button>
                            &nbsp; &nbsp;
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={this.handleCancel.bind(this)}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                        {/* <div className="col-md-9">
                          <div className="col-sm-8 ">
                            <button
                              type="button"
                              className="btn btn-success fa fa-save "
                              onClick={this.handleSubmit.bind(this)}
                            >
                              Confirmed
                            </button>
                          </div>
                        </div> */}
                        {/* <div className="col-md-9">
                          <div className="col-sm-8 ">
                            <button
                              type="button"
                              className="btn btn-success fa fa-save "
                              onClick={this.handleTestEmail.bind(this)}
                            >
                              tes email
                            </button>
                          </div>
                        </div> */}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default ReceiptDocDetail;
